import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import StickyFooter from '../../components/sticky-footer';
import { HorizontalSeparator } from '../../components/separator';
import CommentFormWrapper from '../../components/comment-form-wrapper';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import styles from './post-page-footer-wrapper.scss';

export const PostPageFooterWrapper = ({
  isMobile,
  isSticky,
  stickyThreshold,
  isTyping,
  children,
  cardBackgroundColor: backgroundColor,
}) => {
  if (!isMobile) {
    return (
      <div className={styles.container}>
        <CommentFormWrapper>
          {children}
        </CommentFormWrapper>
      </div>
    );
  }

  const typingHeight = isTyping ? 20 : 0;
  const contentHeight = 60;
  const containerHeight = contentHeight + typingHeight;
  const className = classNames(styles.container, {
    'default-forum-card-background-color': isSticky,
    'forum-card-background-color': !isSticky,
  });
  const style = isSticky ? { backgroundColor } : null;
  const content = (
    <div className={className} style={style}>
      <HorizontalSeparator/>
      {children}
    </div>
  );

  if (!isSticky) {
    return content;
  }

  return (
    <StickyFooter containerHeight={containerHeight} contentHeight={contentHeight} showAfter={stickyThreshold}>
      {content}
    </StickyFooter>
  );
};

PostPageFooterWrapper.propTypes = {
  children: PropTypes.node,
  isSticky: PropTypes.bool,
  stickyThreshold: PropTypes.number,
  isTyping: PropTypes.bool,
  isMobile: PropTypes.bool,
  cardBackgroundColor: PropTypes.string.isRequired,
};

export default withCardBackgroundColor(PostPageFooterWrapper);



// WEBPACK FOOTER //
// ./app/components/post-page-footer-wrapper/post-page-footer-wrapper.js